import pffft from './vendor/pffft.simd'

export interface PFFT {
  blockSize: number
  fftSize: number
  samples: Float32Array
  cosSin: Float64Array
  process(samples: Float32Array): void
  destroy(): void
}

export async function createRunner(blockSize: number): Promise<PFFT> {
  const Module = await pffft()
  const dataPtr = Module._malloc(blockSize * Float32Array.BYTES_PER_ELEMENT)

  const samples = new Float32Array(
    Module.HEAPF32.buffer,
    dataPtr,
    blockSize
  )

  const runner = Module._pffft_runner_new(
    blockSize,
    Float32Array.BYTES_PER_ELEMENT
  )

  const cosSin = new Float64Array(blockSize)
  const fftSize = blockSize / 2
  for (let k = 0, x, p, cos, sin; k < fftSize; k++) {
    x = (Math.min(1, k / (fftSize / 2 - 1)) ** .5) * Math.PI
    p = k * 2
    cos = Math.cos(x)
    sin = Math.sin(x)
    cosSin[p] = cos
    cosSin[p + 1] = sin
  }

  // const fft = new Float32Array(
  //   samples.buffer,
  //   samples.byteOffset,
  //   blockSize
  // )

  return {
    blockSize,
    fftSize,
    samples,
    cosSin,
    process() {
      Module._pffft_runner_transform(runner, samples.byteOffset)
    },

    destroy() {
      Module._free(dataPtr)
      Module._pffft_runner_destroy(runner)
    }
  }
}
